import { clientStore } from 'apps/client/app';
import { Button, Checkbox } from 'components';
import React from 'react';

interface TransferProjectsProps {
  projects: any[];
  selectedProjects: string[];
  onProjectSelected: (projectId: string) => void;
  onTransferProjectsNext: () => void;
  loadingMembersFromProjects: boolean;
  teamName: string;
}

const Project = ({
  checked,
  projectName,
  className,
  slug,
  onClick,
}: {
  isPrivate: boolean;
  slug: string;
  projectName: string;
  checked: boolean;
  className: string;
  onClick?: () => void;
}) => {
  return (
    <div className={`flex h-10 w-full ${className}`}>
      <div className='w-full h-full grid grid-cols-4 items-center'>
        <div className='text-black col-span-2 select-none h-full flex items-center justify-center'>
          <a
            className='hover:text-blue-500 text-black cursor-pointer'
            href={`${clientStore.signedInProfile.username}/${slug}`}
            target='_blank'
            rel='noreferrer'
          >
            {projectName}
          </a>
        </div>
        <div className='col-span-2 flex mb-4 justify-center items-center w-full'>
          <div
            className='w-fit cursor-pointer'
            onClick={() => {
              onClick?.();
            }}
          >
            <Checkbox checked={checked} />
          </div>
        </div>
      </div>
    </div>
  );
};

export const TransferProjects = (props: TransferProjectsProps) => {
  const {
    projects,
    loadingMembersFromProjects,
    selectedProjects,
    onTransferProjectsNext,
    teamName,
  } = props;

  const { isMobile } = clientStore;

  return (
    <div>
      <h1
        className={`${
          isMobile ? 'text-2xl' : ' text-3xl'
        } text-black text-center`}
      >
        Transfer Projects To {teamName}
      </h1>
      <div className='mt-12'>
        {projects.length > 0 && (
          <>
            <div className='w-full h-full grid grid-cols-4 items-center'>
              {/* <div className='font-bold col-span-2 select-none h-full flex items-center justify-start'>
                <span className='text-black font-bold'></span>
              </div> */}
              <div className='font-bold col-span-2 select-none h-full flex items-center justify-center'>
                <span className='text-black font-bold'>Project Name</span>
              </div>
              <div className='col-span-2 flex mb-2 justify-center items-center w-full'>
                <span className='text-black font-bold'>To Transfer</span>
              </div>
            </div>
            {projects.map(project => (
              <Project
                className='mt-4'
                checked={selectedProjects.includes(project.id)}
                isPrivate={project.private}
                key={project.id}
                slug={project.slug}
                projectName={project.name}
                onClick={() => {
                  props.onProjectSelected(project.id);
                }}
              />
            ))}
          </>
        )}
      </div>

      <div className='mt-12 m-auto flex justify-center'>
        <Button
          loading={loadingMembersFromProjects}
          dataTestId='transferProjectsPage-next-button'
          text='Add Collaborators'
          variant='tertiary'
          icon='arrow_right'
          iconPosition='right'
          onClick={() => {
            onTransferProjectsNext();
          }}
          onIconClick={() => {
            onTransferProjectsNext();
          }}
        />
      </div>
    </div>
  );
};
